import { TableColumn } from '../../../../../components/datatables/columns/DefaultColumn/DefaultColumn';
import { ProjectDocFolderCUser } from '../../../../workflows/models/ProjectDocFolderCUser';
import { ApproverEditColumn } from './ApproverEditColumn';
import { ApproverTitleColumn } from './ApproverTitleColumn';

export const folderApproversListColumns = (
  isEditMode: boolean,
  hasNewRow: boolean,
  getEditable: (item: ProjectDocFolderCUser) => boolean,
  onAddRow: () => void,
  onSave: (item: ProjectDocFolderCUser) => void,
  onUpdate: (item: ProjectDocFolderCUser) => void,
  onEditableChanged: (item: ProjectDocFolderCUser, editable: boolean) => void,
  onDelete: (item: ProjectDocFolderCUser) => void
): TableColumn[] => {
  return isEditMode ? [
    { ...ApproverEditColumn(hasNewRow, getEditable, onAddRow, onSave, onEditableChanged, onDelete) },
    { ...ApproverTitleColumn(getEditable, onUpdate), field: `User.Title`, header: `Наименование`, filter: false },
    { field: `User.Email`, header: `Email`, filter: false },
  ] : [
    { field: `User.Title`, header: `Наименование` },
    { field: `User.Email`, header: `Email`, filter: false },
  ];
};